// Components==============
import React from 'react';
// import AssessmentNotification from '../Notification/AssessmentNotification';
import FeedbackNotification from '../Notification/FeedbackNotification';
import InviteNotification from '../Notification/InviteNotification';
import Notification from '../Notification/Notification';
import './RecentActivity.module.scss';
// =========================

export default function RecentActivity({
  activity,
}: {
  activity: RecentActivityEntity;
}) {
  if (!activity?.activity) return <></>;

  return (
    <>
      {activity.type === 'feedback' ? (
        <FeedbackNotification activity={activity.activity as FeedbackEntity} />
      ) : activity.type === 'invite' ? (
        <InviteNotification
          activity={activity.activity as ProjectGroupEntity}
        />
      ) : activity.type === 'reflection-invite' ? (
        <InviteNotification
          reflection={activity.activity as ReflectionEntity}
        />
      ) : activity.type === 'notification' ? (
        <Notification activity={activity.activity as NotificationEntity} />
      ) : // <AssessmentNotification
      //   activity={activity.activity as AssessmentEntity}
      // />
      null}
    </>
  );
}
